import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
import invoicesD0c47e from './invoices'
/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
export const checkout = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkout.url(args, options),
    method: 'get',
})

checkout.definition = {
    methods: ["get","head"],
    url: '/subscriptions/checkout/{plan}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
checkout.url = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { plan: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { plan: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            plan: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        plan: typeof args.plan === 'object'
        ? args.plan.id
        : args.plan,
    }

    return checkout.definition.url
            .replace('{plan}', parsedArgs.plan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
checkout.get = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkout.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
checkout.head = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: checkout.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
const checkoutForm = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkout.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
checkoutForm.get = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkout.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::checkout
* @see app/Http/Controllers/SubscriptionController.php:31
* @route '/subscriptions/checkout/{plan}'
*/
checkoutForm.head = (args: { plan: string | number | { id: string | number } } | [plan: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkout.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

checkout.form = checkoutForm

/**
* @see \App\Http\Controllers\SubscriptionController::subscribe
* @see app/Http/Controllers/SubscriptionController.php:47
* @route '/subscriptions/subscribe'
*/
export const subscribe = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: subscribe.url(options),
    method: 'post',
})

subscribe.definition = {
    methods: ["post"],
    url: '/subscriptions/subscribe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SubscriptionController::subscribe
* @see app/Http/Controllers/SubscriptionController.php:47
* @route '/subscriptions/subscribe'
*/
subscribe.url = (options?: RouteQueryOptions) => {
    return subscribe.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::subscribe
* @see app/Http/Controllers/SubscriptionController.php:47
* @route '/subscriptions/subscribe'
*/
subscribe.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: subscribe.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::subscribe
* @see app/Http/Controllers/SubscriptionController.php:47
* @route '/subscriptions/subscribe'
*/
const subscribeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: subscribe.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::subscribe
* @see app/Http/Controllers/SubscriptionController.php:47
* @route '/subscriptions/subscribe'
*/
subscribeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: subscribe.url(options),
    method: 'post',
})

subscribe.form = subscribeForm

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
export const manage = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: manage.url(options),
    method: 'get',
})

manage.definition = {
    methods: ["get","head"],
    url: '/subscriptions/manage',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
manage.url = (options?: RouteQueryOptions) => {
    return manage.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
manage.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: manage.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
manage.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: manage.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
const manageForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manage.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
manageForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manage.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::manage
* @see app/Http/Controllers/SubscriptionController.php:140
* @route '/subscriptions/manage'
*/
manageForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manage.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

manage.form = manageForm

/**
* @see \App\Http\Controllers\SubscriptionController::swap
* @see app/Http/Controllers/SubscriptionController.php:189
* @route '/subscriptions/swap'
*/
export const swap = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: swap.url(options),
    method: 'post',
})

swap.definition = {
    methods: ["post"],
    url: '/subscriptions/swap',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SubscriptionController::swap
* @see app/Http/Controllers/SubscriptionController.php:189
* @route '/subscriptions/swap'
*/
swap.url = (options?: RouteQueryOptions) => {
    return swap.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::swap
* @see app/Http/Controllers/SubscriptionController.php:189
* @route '/subscriptions/swap'
*/
swap.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: swap.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::swap
* @see app/Http/Controllers/SubscriptionController.php:189
* @route '/subscriptions/swap'
*/
const swapForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: swap.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::swap
* @see app/Http/Controllers/SubscriptionController.php:189
* @route '/subscriptions/swap'
*/
swapForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: swap.url(options),
    method: 'post',
})

swap.form = swapForm

/**
* @see \App\Http\Controllers\SubscriptionController::cancel
* @see app/Http/Controllers/SubscriptionController.php:367
* @route '/subscriptions/cancel'
*/
export const cancel = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/subscriptions/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SubscriptionController::cancel
* @see app/Http/Controllers/SubscriptionController.php:367
* @route '/subscriptions/cancel'
*/
cancel.url = (options?: RouteQueryOptions) => {
    return cancel.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::cancel
* @see app/Http/Controllers/SubscriptionController.php:367
* @route '/subscriptions/cancel'
*/
cancel.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::cancel
* @see app/Http/Controllers/SubscriptionController.php:367
* @route '/subscriptions/cancel'
*/
const cancelForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::cancel
* @see app/Http/Controllers/SubscriptionController.php:367
* @route '/subscriptions/cancel'
*/
cancelForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(options),
    method: 'post',
})

cancel.form = cancelForm

/**
* @see \App\Http\Controllers\SubscriptionController::resume
* @see app/Http/Controllers/SubscriptionController.php:388
* @route '/subscriptions/resume'
*/
export const resume = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(options),
    method: 'post',
})

resume.definition = {
    methods: ["post"],
    url: '/subscriptions/resume',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SubscriptionController::resume
* @see app/Http/Controllers/SubscriptionController.php:388
* @route '/subscriptions/resume'
*/
resume.url = (options?: RouteQueryOptions) => {
    return resume.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::resume
* @see app/Http/Controllers/SubscriptionController.php:388
* @route '/subscriptions/resume'
*/
resume.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::resume
* @see app/Http/Controllers/SubscriptionController.php:388
* @route '/subscriptions/resume'
*/
const resumeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::resume
* @see app/Http/Controllers/SubscriptionController.php:388
* @route '/subscriptions/resume'
*/
resumeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(options),
    method: 'post',
})

resume.form = resumeForm

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
export const invoices = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: invoices.url(options),
    method: 'get',
})

invoices.definition = {
    methods: ["get","head"],
    url: '/subscriptions/invoices',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
invoices.url = (options?: RouteQueryOptions) => {
    return invoices.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
invoices.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: invoices.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
invoices.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: invoices.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
const invoicesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: invoices.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
invoicesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: invoices.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::invoices
* @see app/Http/Controllers/SubscriptionController.php:417
* @route '/subscriptions/invoices'
*/
invoicesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: invoices.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

invoices.form = invoicesForm

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
export const usage = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: usage.url(options),
    method: 'get',
})

usage.definition = {
    methods: ["get","head"],
    url: '/subscriptions/usage',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
usage.url = (options?: RouteQueryOptions) => {
    return usage.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
usage.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: usage.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
usage.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: usage.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
const usageForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: usage.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
usageForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: usage.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::usage
* @see app/Http/Controllers/SubscriptionController.php:436
* @route '/subscriptions/usage'
*/
usageForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: usage.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

usage.form = usageForm

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
export const callback = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/subscriptions/callback/{gateway}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
callback.url = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gateway: args }
    }

    if (Array.isArray(args)) {
        args = {
            gateway: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gateway: args.gateway,
    }

    return callback.definition.url
            .replace('{gateway}', parsedArgs.gateway.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
callback.get = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
callback.head = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
const callbackForm = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
callbackForm.get = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubscriptionController::callback
* @see app/Http/Controllers/SubscriptionController.php:458
* @route '/subscriptions/callback/{gateway}'
*/
callbackForm.head = (args: { gateway: string | number } | [gateway: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

callback.form = callbackForm

/**
* @see \App\Http\Controllers\SubscriptionController::validateCoupon
* @see app/Http/Controllers/SubscriptionController.php:518
* @route '/subscriptions/validate-coupon'
*/
export const validateCoupon = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateCoupon.url(options),
    method: 'post',
})

validateCoupon.definition = {
    methods: ["post"],
    url: '/subscriptions/validate-coupon',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SubscriptionController::validateCoupon
* @see app/Http/Controllers/SubscriptionController.php:518
* @route '/subscriptions/validate-coupon'
*/
validateCoupon.url = (options?: RouteQueryOptions) => {
    return validateCoupon.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubscriptionController::validateCoupon
* @see app/Http/Controllers/SubscriptionController.php:518
* @route '/subscriptions/validate-coupon'
*/
validateCoupon.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateCoupon.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::validateCoupon
* @see app/Http/Controllers/SubscriptionController.php:518
* @route '/subscriptions/validate-coupon'
*/
const validateCouponForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: validateCoupon.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SubscriptionController::validateCoupon
* @see app/Http/Controllers/SubscriptionController.php:518
* @route '/subscriptions/validate-coupon'
*/
validateCouponForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: validateCoupon.url(options),
    method: 'post',
})

validateCoupon.form = validateCouponForm

const subscriptions = {
    checkout: Object.assign(checkout, checkout),
    subscribe: Object.assign(subscribe, subscribe),
    manage: Object.assign(manage, manage),
    swap: Object.assign(swap, swap),
    cancel: Object.assign(cancel, cancel),
    resume: Object.assign(resume, resume),
    invoices: Object.assign(invoices, invoicesD0c47e),
    usage: Object.assign(usage, usage),
    callback: Object.assign(callback, callback),
    validateCoupon: Object.assign(validateCoupon, validateCoupon),
}

export default subscriptions